import SuppliersReport from './SuppliersReportController';

export default SuppliersReport;
